import { z } from 'zod';

// 成功系 Response Schema
export const ApiResponseSchemaOnSuccess = z.union([
  z.record(z.any()),
  z.array(z.any()),
  z.object({}),
  z.boolean(),
]);

// 失敗系 Response Schema
export const ApiResponseSchemaOnFailure = z.union([
  z.object({
    level: z.union([z.literal('WARNING'), z.literal('FATAL')]),
    code: z.string(),
    message: z.string(),
    invalidInfos: z.array(
      z.object({
        field: z.string(),
        rule: z.string(),
        index: z.number(),
        setting: z.record(z.string()),
        message: z.string(),
      })
    ),
  }),
  z.null(),
]);
